import { Link } from 'react-router-dom'
import globalStyle from '../../styles/common.module.css'
import style from './homepage.module.css'
import { PagesQuery } from '../../util/types'
import React from 'react'

function Homepage({data}: {data: PagesQuery["pages"][number] | undefined}) {
  if (!data) {
    return null;
  }

  return (
    <div className={[style.wrapper].join(' ')}>
      <div className={[style.noteWrapper, style.noteWrapper1].join(' ')}>
        <img src='assets/note1.png' alt='Consider neutral language like "living with" — versus "struggling with."' />
      </div>
      <div className={[style.titleWrapper].join(' ')}>
        <h1 className={style.title}> {data.title} </h1>
      </div>

      <div className={[globalStyle.gridFlex, style.blurbWrapper].join(' ')}>
        <div className={[globalStyle.grid6, style.blurbNotes].join(' ')}>
          <div className={[style.noteWrapper, style.noteWrapper2].join(' ')}>
            <img src='assets/note2.png' alt='When identifying people, follow an individual’s preference and be as specific as possible.' />
          </div>
          <div className={[style.noteWrapper, style.noteWrapper3].join(' ')}>
            <img src='assets/note3.png' alt='Careful not to conflate sex work, which people consent to, versus sex trafficking.' />
          </div>
        </div>
        <div className={[style.blurb, globalStyle.grid5].join(' ')}>
          {
            data.blurb && 
          <div className={globalStyle.bodySM} dangerouslySetInnerHTML={{ __html: data.blurb.html }} />
          }
           <Link className={[style.startButton, globalStyle.buttonSM].join(' ')} to={`/instructions`}>
                <img src='assets/icons/start3.svg' alt='temp' />
                Edit away
              </Link>
        </div>
      </div>

    </div>
  );
}

export { Homepage }